const BuyBackCustomField = {
  path: "",
  name: "",
  redirect: "custom-field",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  meta: {
    requiresAuth: true,
    activeUrl: "/setting",
    isChildren: true,
    lv: 2,
  },
  children: [
    {
      path: "custom-field",
      name: "Buy-Back Custom Field",
      redirect: "custom-field",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      meta: {
        requiresAuth: true,

        activeUrl: "/setting",
        isChildren: true,
        lv: 2,
      },
      children: [
        {
          path: "",
          name: "",
          component: () =>
            import("@/views/pages/setting/settingPage/buyBack/CustomField"),
          meta: {
            requiresAuth: true,
            activeUrl: "custom-field",
            parent: "/custom-field",

            lv: 2,
          },
        },
      ],
    },
  ],
};
const BuyBackSetting = {
  path: "",
  name: "",
  redirect: "buy-back",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  meta: {
    requiresAuth: true,
    activeUrl: "/setting",
    isChildren: true,
    lv: 2,
  },
  children: [
    {
      path: "buy-back",
      name: "Buy Back",
      redirect: "buy-back",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      meta: {
        requiresAuth: true,
        activeUrl: "/setting",
        isChildren: true,
        lv: 2,
      },
      children: [
        {
          path: "",
          name: "",
          component: () =>
            import("@/views/pages/setting/settingPage/buyBack/index"),
          meta: {
            requiresAuth: true,
            activeUrl: "/setting",
            isChildren: true,
            lv: 3,
          },
        },
        {
          path: "detail",
          name: "Buy Back Detail",
          component: () =>
            import("@/views/pages/setting/settingPage/buyBack/detail"),
          meta: {
            requiresAuth: true,
            activeUrl: "detail",
            isChildren: true,
            lv: 3,
          },
        },
        // ProductRepair,
        BuyBackCustomField,
      ],
    },
  ],
};
export default BuyBackSetting;
